import React from 'react';
import './WhatWeBuild.scss';

type Pillar = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

const PILLARS: Pillar[] = [
  {
    title: 'Móvil',
    description: 'Apps nativas y multiplataforma que se sienten en casa en cada dispositivo.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="2" width="12" height="20" rx="2.5" />
        <line x1="11" y1="18.5" x2="13" y2="18.5" />
      </svg>
    ),
  },
  {
    title: 'Web',
    description: 'Productos web rápidos y modernos, hechos con claridad, escala y buen gusto.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2.5" y="4" width="19" height="14" rx="2" />
        <line x1="2.5" y1="9" x2="21.5" y2="9" />
        <line x1="9" y1="22" x2="15" y2="22" />
        <line x1="12" y1="18" x2="12" y2="22" />
      </svg>
    ),
  },
  {
    title: 'Escritorio',
    description: 'Herramientas potentes que respetan el enfoque y se mantienen fuera del camino.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="13" rx="2" />
        <line x1="7" y1="20" x2="17" y2="20" />
        <line x1="12" y1="16" x2="12" y2="20" />
      </svg>
    ),
  },
  {
    title: 'IoT',
    description: 'Experiencias de hardware conectado donde el software desaparece.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="2.25" />
        <path d="M8 8a5.5 5.5 0 0 1 8 0" />
        <path d="M5 5a9.5 9.5 0 0 1 14 0" />
        <path d="M8 16a5.5 5.5 0 0 0 8 0" />
        <path d="M5 19a9.5 9.5 0 0 0 14 0" />
      </svg>
    ),
  },
];

const WhatWeBuild: React.FC = () => {
  return (
    <section className="wwb">
      <div className="container">
        <div className="wwb__header">
          <p className="wwb__label">Qué construimos</p>
          <h2 className="wwb__title">
            Software que <span className="gradient-text">importa</span>, en cada superficie.
          </h2>
        </div>

        <div className="wwb__grid">
          {PILLARS.map((p) => (
            <article key={p.title} className="wwb__card">
              <span className="wwb__icon" aria-hidden="true">{p.icon}</span>
              <h3 className="wwb__card-title">{p.title}</h3>
              <p className="wwb__card-desc">{p.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeBuild;
